module.exports = __webpack_public_path__ + "img/front.72b46766.png";